import styled from 'styled-components';

export const FCCancellationPolicyTimelineWrapper = styled.div(
  props => `
.fcDetails {
    width: 100%;
    box-shadow: 0 0 5px 0 rgba(150, 150, 150, 0.5);
	background-color: #fff;
	padding: 20px 24px;
	border-radius: 4px;
    text-align: left;
    z-index: 1;
}

.appendTop8{
    margin-top: 8px;
}

.makeFlex {
    display: flex;
}

.makeFlex.hrtlCenter {
    align-items: center;
}

.appendTop12{
    margin-top: 12px;
}

.appendBottom12{
    margin-bottom: 12px;
}

.appendBottom3{
    margin-bottom: 3px;
}

.fcDetails__top {
	display: flex;
	align-items: center;
	margin-bottom: 12px;
}
.fcDetails__bar {
	height: 24px;
	border-radius: 21.5px;
	box-shadow: 1px 1px 2px -1px rgba(163, 155, 155, 0.22);
	border: solid 1px #b9d1cf;
	background-color: #ffffff;
	overflow: hidden;
}
.fcDetails__bar--complete {
	height: 100%;
    background-image: linear-gradient(260deg, #2eb4af, #249995);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 5px;
}
.interstitial .fcDetails__bar--complete {
    background: linear-gradient(to right, #EBEFF2 8%, #F9FAFB 18%, #EBEFF2 33%);
}
.fcWidth100{
    width: 100%;
}
.fcWidth80{
    width: 80%;
}
.fcDetails__bar-oval {
    display: inline-block;
	width: 16px;
	height: 16px;
	box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.5);
    background-color: #ffffff;
    border-radius: 16px;
}
.fcDetails__bar-text {
    font-size: 10px;
}
.fcDetails__bottom{
    display: flex;
}
.fcDetails__bottom--left{
    width: 80%;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
}
.fcDetails__bottom--left > span{
    padding-top: 12px;
    position: relative;
}
.fcDetails__bottom--left > span.barLine{
    padding-right: 8px;
}
.fcDetails__bottom--left > span.barLine::after{
    width: 1px;
    height: 22px;
    background-color: #2eb4af;
    content: "";
    position: absolute;
    right: 0;
    top: 0;
}
.fcDetails__bottom--right{
    padding-top: 12px;
    display: flex;
    flex-direction: column;
    text-align: right;
    flex: 1;
}
.fcListingTile {
    width: 368px;
    box-shadow: 0 0 5px 0 rgba(150, 150, 150, 0.5);
}
.fcRoomDetails {
    width: 368px;
    box-shadow: 0 0 5px 0 rgba(150, 150, 150, 0.5);
    position: absolute;
    left: 0;
    top: 40px;
}
.fcTimelineReviewPg {
    width: 100%;
    padding: 0px;
    box-shadow: none;
    border: 0;
    border-radius: 0;
    background-color: transparent;
}
.fcFullPolicyModal {
    width: 100%;
    padding: 15px 20px 15px 20px;
    box-shadow: none;
    border: 1px #a7d4cf solid;
    border-radius: 4px;
    background-color: transparent;
    margin-bottom:20px;
}
.pwaHotelMainCard {
    width: 100%;
    box-shadow: none;
    border-radius: 0;
}
.pwaReviewPg {
	width: 100%;
    box-shadow: none;
    border-radius: 0;
	border-top: 1px #e7e7e7 solid;
	border-bottom: 1px #e7e7e7 solid;
}
.pwaMoreInfoOverlay {
	box-shadow: none;
    border-radius: 0;
    padding: 15px 20px 15px 20px;
    margin: 0 -16px 15px -16px;
	border-top: 1px #e7e7e7 solid;
	border-bottom: 1px #e7e7e7 solid;
}
.pwaHotelReviewNew {
    width: 100%;
    box-shadow: none;
    border-radius: 0;
    padding: 0;
    margin-top: 10px;
}
.pwaHotelReviewNewPopup {
    width: 100%;
    box-shadow: none;
    border-radius: 0;
    padding: 0;
    margin-top: 0;
}
.dtHotelReviewNew {
    width: 340px;
    box-shadow: none;
    background-color: transparent;
    margin-top: 10px;
}
.dtHotelReviewNewPopup {
    width: 100%;
    box-shadow: none;
    background-color: transparent;
    padding: 0;
}
.fcPwaReviewSnapshot {
    width: 100%;
    box-shadow: none;
    border-radius: 0;
    padding-bottom: 0;
    margin-bottom: 15px;
}
html[dir="rtl"] .fcDetails__bottom--right {
    text-align: left;
}
html[dir="rtl"] .fcDetails__bottom--left > span.barLine::after {
    left: 0;
    right: unset;
}
html[dir="rtl"] .fcDetails__bottom--left > span.barLine {
    padding-left: 8px;
    text-align: left;
}
html[dir="rtl"] .fcTitle {
    text-align: right;
}
.fcListingTileDesktopCg {
    padding-top: 15px;
    width: 368px;
    box-shadow: 0 0 5px 0 rgba(150, 150, 150, 0.5);
}
.fcPwaSelectNew {
    width: 100%;
    box-shadow: none;
    border-radius: 0;
}
.dtNewDetailsPg {
    padding-top: 15px !important;
    width: 368px;
    box-shadow: 0 0 5px 0 rgba(150, 150, 150, 0.5);
    position: absolute;
    left: 0;
    top: 40px;
}
.dtNewDetailsPg::after{
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    margin-left: -8px;
    top: 0;
    left: 20%;
    border: 8px solid #000;
    box-sizing: border-box;
    border-color: transparent transparent #fff #fff;
    transform-origin: 0 0;
    transform: rotate(135deg);
    box-shadow: -4px 3px 4px -3px rgb(0 0 0 / 40%);
}
.fcDetails.dtComboDtlPopup{
    box-shadow: none;
    border: 0;
    padding: 0;
    border-radius: 0;
    width: 80%;
}
`,
);
